
import { axios } from "@/utils/axios.create";

const exportExcel = async (programId: string): Promise<{
  downloadUrl: string;
  fileName: string;
}> => {
  const queryParams = new URLSearchParams({
    programId,
  });
  return axios
    .get(`/contextual-agent/responses/export?${queryParams.toString()}`)
    .then((res) => res.data.body)
    .catch((err) => {
      throw new Error(
        err.response?.data?.message || "Failed to fetch enrollment"
      );
    });
};

export const ContextualAgentService = {
  exportExcel,
};
